<template>
  <div @mouseleave="handleMenuMouseLeave">
    <li
    data-test="sidelist-item"
    @click="selectItem($event)"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    class="ff-sidelist__list-item is-page"
    :class="{'can-edit': isOwner}"
    ref="li">
      <cv-button class="sl-button" v-tooltip="tooltip">
        <i class="handle" :class="{'is-active': hover, 'is-hidden': !isOwner}"></i>
        <span class="sl-button__text">{{title}}</span>
        <button data-test="user-lock-sidebar" class="sl-upgrade__action" type="button" name="button" @click="upgrade" v-tooltip="'Upgrade to View'" v-if="showUpgradeAction && !isOwner">🔒</button>
        <button class="sl-upgrade__action" type="button" name="button" v-if="showUpgradeAction && isOwner">🔒</button>
      </cv-button>
    </li>
    <!-- <ff-menu
      v-if="children.length"
      class="menu"
      :class="{'is-active': show}"
      :items="children"
      :label="'More'"
      :style="style"
      @action="selectChild"
      @mouseleave="handleMenuMouseLeave"
    /> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import FFMenu from './FFMenu'
import _ from 'lodash'

export default {
  name: 'ff-sidelist-item',
  components: {
    // 'ff-menu': FFMenu
  },
  props: [
    'item',
    'action'
  ],
  data () {
    return {
      showPicker: false,
      hasToggled: false,
      hover: false,
      children: [],
      show: false,
      menu_top: 0,
      handleShow: null
    }
  },
  computed: {
    ...mapState(['channel', 'user']),
    style () {
      let s = {}
      s.top = this.menu_top
      s.right = '1rem'
      return s
    },
    title () {
      // let doc = new DOMParser().parseFromString(this.item.title, "text/html")
      // return doc.documentElement.textContent
      return _.unescape(this.item.title)
    },
    isOwner () {
      if (!this.user) return
      return this.channel.owner === this.user.uid || !this.user.uid
    },
    showUpgradeAction () {
      // If there's no tier there's no point
      if (!this.item.tier) return false
      // Don't show to paid fans
      if (this.channel && this.channel.fans) {
        if (this.user && this.user.uid) {
          let fan = this.channel.fans[this.user.uid]
          if (fan && fan.tier && fan.tier != 'free') {
            return false
          }
        }
      }

      // Otherwise pretty much show if it's not free
      return this.item.tier && this.item.tier !== 'public'
    },
    tooltip () {
      if (!this.children.length) return
      return `${this.children.length} more pages...`
    }
  },
  created () {
    this.children = this.channel.pages.filter((val) => val.parent === this.item.id)
  },
  mounted () {
  },
  methods: {
    upgrade (e) {
      e.stopPropagation()
      this.$router.push({name: 'channel-landing', query: { login: true }})
    },
    selectChild (e) {
      this.hover = false;
      this.show = false;
      return this.action(e.id)
    },
    selectItem () {
      return this.action(this.item.id)
    },
    handleMouseEnter () {
      this.hover = true;
      if (this.children) {
        const rect = this.$refs.li.getBoundingClientRect();
        this.menu_top = `${rect.bottom}px`
        this.handleShow = setTimeout(() => {
          this.show = true
        }, 320)
      }
    },
    handleMouseLeave () {
      this.hover = false;
    },
    handleMenuMouseLeave () {
      this.hover = false;
      clearTimeout(this.handleShow)
      this.show = false;
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .menu {
    position: absolute;
    display: none;

    &.is-active {
      display: block;
      animation: show .12s ease;
    } // TODO - ani isn't working here
  }

</style>
